/**
 * 通用的展示+按钮界面
 */
import classNames from 'classnames';
import { Button } from 'rc-ui-lib';
import { Ref, useMemo } from 'react';
import { nativeApi } from '../../utils/nativeApi';
import { Platform } from '../../utils/nativeApi/interface';
import lessStyle from './index.module.less';

export type commonLayoutProps = {
  children: React.ReactNode;
  btnText: string;
  onClickBtn: () => void;
  btnDisable?: boolean;
  btnLoading?: boolean;
  showBtn?: boolean;
  style?: React.CSSProperties;
  layoutRef?: Ref<HTMLDivElement>;
  btnCls?: string;
  btnPrefix?: React.ReactNode;
  subBtnText?: string;
  onClickSubBtn?: () => void;
  customBtn?: React.ReactNode;
  btnWrapperCls?: string;
  footer?: React.ReactNode;
  subBtnCls?: string;
};

function CommonLayout(props: commonLayoutProps) {
  const {
    children,
    btnText,
    onClickBtn,
    btnDisable,
    btnLoading,
    showBtn,
    style,
    layoutRef,
    btnCls,
    btnPrefix,
    subBtnText,
    onClickSubBtn,
    customBtn,
    btnWrapperCls,
    footer,
    subBtnCls,
  } = props;

  const isInMobileWeb = useMemo(() => nativeApi.name === Platform.MobileWebClient, []);

  const isNew = nativeApi.isNewVersion;
  return (
    <div
      className={classNames(lessStyle.layout, {
        [lessStyle.max_height]: !isInMobileWeb,
      })}
      style={style}
      ref={layoutRef}
    >
      <div className={lessStyle.content}>{children}</div>
      {footer ||
        (showBtn ? (
          <div className={lessStyle.btn_wrapper_container}>
            {btnPrefix}
            <div
              className={classNames(
                lessStyle.btn_wrapper,
                {
                  [lessStyle.btn_wrapper_isNew]: isNew,
                  [lessStyle.btn_basic]: !isInMobileWeb,
                },
                btnWrapperCls
              )}
            >
              {customBtn || (
                <>
                  <Button
                    className={`${classNames(lessStyle.btn, btnCls, {
                      isNew,
                    })}`}
                    type="primary"
                    onClick={onClickBtn}
                    disabled={btnDisable}
                    loading={btnLoading}
                  >
                    {btnText}
                  </Button>
                  {subBtnText ? (
                    <div
                      onClick={onClickSubBtn}
                      className={classNames(lessStyle.sub_btn, subBtnCls)}
                    >
                      {subBtnText}
                    </div>
                  ) : null}
                </>
              )}
            </div>
          </div>
        ) : undefined)}
    </div>
  );
}

CommonLayout.defaultProps = {
  btnDisable: false,
  btnLoading: false,
  showBtn: true,
};

export default CommonLayout;
